export default __webpack_public_path__ + "static/media/union-pay.6c9d76cd.svg";